import React from 'react';

export default function PrivacyPage() {
  return (
    <div style={{
      maxWidth: 800,
      margin: '0 auto',
      padding: '40px 24px 80px',
      fontFamily: "'Inter', sans-serif",
      color: '#0d0d0b',
      lineHeight: 1.7,
    }}>
      <h1 style={{
        fontFamily: "'Fraunces', serif",
        fontSize: 32,
        fontWeight: 500,
        marginBottom: 8,
        color: '#0d0d0b',
      }}>
        Політика конфіденційності
      </h1>
      <p style={{ color: '#6b6560', fontSize: 14, marginBottom: 40 }}>
        Ресторан «Околиця» — okolitsya-lentochka.com.ua
      </p>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>1. Загальні положення</h2>
        <p>1.1. Ця Політика захисту та обробки персональних даних складена відповідно до вимог Закону України «Про захист персональних даних» та визначає порядок обробки персональних даних на сайті <strong>okolitsya-lentochka.com.ua</strong> (далі — Сайт).</p>
        <p>1.2. Інтернет-магазин ставить найважливішою метою дотримання прав і свобод людини при обробці персональних даних, в тому числі захисту прав на недоторканість приватного життя.</p>
        <p>1.3. Політика розповсюджується на всіх осіб, які вступають або можуть вступати у будь-які відносини з Інтернет-магазином.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>2. Визначення термінів</h2>
        <ul style={ulStyle}>
          <li><strong>Володілець персональних даних</strong> — ФОП Візнюк Олена Василівна (Інтернет-магазин).</li>
          <li><strong>Персональні дані (ПД)</strong> — відомості про фізичну особу, яка ідентифікована або може бути ідентифікована.</li>
          <li><strong>Клієнт</strong> — фізична особа, яка є споживачем товарів/послуг Інтернет-магазину.</li>
          <li><strong>Обробка персональних даних</strong> — будь-яка дія з персональними даними: збирання, зберігання, використання, передача, знищення.</li>
          <li><strong>Сайт</strong> — веб-сайт <a href="https://okolitsya-lentochka.com.ua" style={linkStyle}>okolitsya-lentochka.com.ua</a>.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>3. Які дані ми збираємо</h2>
        <p>3.1. При оформленні замовлення або реєстрації на сайті ми можемо збирати:</p>
        <ul style={ulStyle}>
          <li>прізвище, ім'я, по батькові;</li>
          <li>номер телефону;</li>
          <li>адресу електронної пошти;</li>
          <li>адресу доставки;</li>
          <li>дані платіжних транзакцій (не зберігаємо дані карток);</li>
          <li>файли cookie та технічні дані браузера.</li>
        </ul>
        <p>3.2. Ми не обробляємо дані про расове походження, політичні переконання, стан здоров'я, біометричні або генетичні дані.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>4. Мета збору даних</h2>
        <p>4.1. Ваші персональні дані використовуються виключно для:</p>
        <ul style={ulStyle}>
          <li>обробки та виконання замовлень;</li>
          <li>зв'язку з Вами щодо замовлення;</li>
          <li>доставки товарів;</li>
          <li>покращення роботи сайту;</li>
          <li>дотримання вимог законодавства України.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>5. Передача даних третім особам</h2>
        <p>5.1. Ми можемо передавати Ваші дані третім особам лише у випадках:</p>
        <ul style={ulStyle}>
          <li>виконання замовлення (служби доставки, платіжні системи);</li>
          <li>виконання вимог законодавства;</li>
          <li>захисту законних інтересів Інтернет-магазину.</li>
        </ul>
        <p>5.2. Ми повідомляємо Вас про передачу даних третім особам протягом 10 робочих днів, крім випадків, передбачених законом.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>6. Файли cookie</h2>
        <p>6.1. Сайт використовує файли cookie для покращення роботи та аналізу відвідуваності. Cookie — це невеликі файли даних, що зберігаються на Вашому пристрої.</p>
        <p>6.2. Ви можете відмовитися від cookie у налаштуваннях браузера. При цьому деякі функції сайту можуть бути недоступні.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>7. Зберігання та захист даних</h2>
        <p>7.1. Ми вживаємо всіх необхідних технічних та організаційних заходів для захисту Ваших персональних даних від несанкціонованого доступу.</p>
        <p>7.2. Персональні дані зберігаються на серверах виключно на території України або в країнах, що забезпечують належний рівень захисту.</p>
        <p>7.3. Дані знищуються або знеособлюються після досягнення мети їх обробки.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>8. Ваші права</h2>
        <p>8.1. Відповідно до законодавства України Ви маєте право:</p>
        <ul style={ulStyle}>
          <li>знати про джерела збору та використання Ваших даних;</li>
          <li>отримати доступ до своїх персональних даних;</li>
          <li>вимагати виправлення неточних даних;</li>
          <li>вимагати видалення Ваших даних;</li>
          <li>відкликати згоду на обробку даних.</li>
        </ul>
        <p>8.2. Для реалізації своїх прав звертайтесь за телефоном: <strong>+380 (96) 736-51-96</strong>.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>9. Зміни до Політики</h2>
        <p>9.1. Ми залишаємо за собою право вносити зміни до цієї Політики. Актуальна версія завжди доступна на сайті.</p>
        <p>9.2. Продовження використання сайту після внесення змін означає Вашу згоду з оновленою Політикою.</p>
      </section>

      <section style={{
        marginTop: 40,
        padding: '20px 28px',
        background: '#f9f6f1',
        borderRadius: 16,
        border: '1px solid #e8ddd0',
        fontSize: 14,
        color: '#6b6560',
      }}>
        <strong style={{ color: '#0d0d0b' }}>Контакти:</strong><br />
        ФОП Візнюк Олена Василівна<br />
        Телефон: +380 (96) 736-51-96<br />
        Сайт: okolitsya-lentochka.com.ua
      </section>
    </div>
  );
}

const h2Style = {
  fontFamily: "'Fraunces', serif",
  fontSize: 20,
  fontWeight: 500,
  marginBottom: 12,
  marginTop: 0,
  color: '#0d0d0b',
};

const ulStyle = {
  paddingLeft: 20,
  marginTop: 8,
};

const linkStyle = {
  color: '#8b6914',
  textDecoration: 'underline',
};
